import _ from 'lodash'
import axios from 'axios'
import { IFile } from '@/configs/define'
import cryptoJS from 'crypto-js'

const prefix = '/avi-flight'

const urlPrefix = 'flight'
export const xAuthToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ3b3Jrc3BhY2VfaWQiOiJlM2RlYTBmNS0zN2YyLTRkNzktYWU1OC00OTBhZjMyMjgwNjkiLCJzdWIiOiJDbG91ZEFwaVNhbXBsZSIsInVzZXJfdHlwZSI6IjEiLCJuYmYiOjE2NTcxODUzODIsImxvZyI6IkxvZ2dlcltjb20uc2hpbmUuY2hlcnJ5LnNlcnZpY2UuZmxpZ2h0LmNvbnRyb2wuY29tbW9uLm1vZGVsLkN1c3RvbUNsYWltXSIsImlzcyI6IkRKSSIsImlkIjoiYTE1NTllN2MtOGRkOC00NzgwLWI5NTItMTAwY2M0Nzk3ZGEyIiwiZXhwIjo0ODEwNzg1MzgyLCJpYXQiOjE2NTcxODUzODIsInVzZXJuYW1lIjoiYWRtaW5QQyJ9.JgMzKSoPQxs4d9mlAE1Ms42VgTr60pDwa8hBqvD0tmM'

export function getCarsInfo() {
  return axios.get(`${urlPrefix}/positionMonitor/findCar`)
}

// 根据任务id查询车辆定位
export function getLocation(taskId:string) {
  return axios.get(`/dispatch1/commandTheBigScreen/findCarAndPeopleAndDrone?taskId=${taskId}`)
}
// 获取任务列表
export function taskList() {
  return axios.get('/dispatch1/dispatch/task/list')
}

export function getJtkjToken(params:any) {
  return axios({
    url: `${process.env.VUE_APP_API_JTKJGPS_URL}/video/user/api/login`,
    method: 'post',
    params,
  })
}

export function getCarLocation1(data:any) {
  return axios.post(`${process.env.VUE_APP_API_JTKJGPS_URL}/video/monitor/api/getPositionByPlate`, data, {
    headers: {
      // 'Content-Type': 'application/json',
      Authorization: sessionStorage.getItem('gpsToken') || '',
    },
  })
}
